import { render, staticRenderFns } from "./FundDetails.vue?vue&type=template&id=6c9d02fa&scoped=true"
import script from "./FundDetails.vue?vue&type=script&lang=js"
export * from "./FundDetails.vue?vue&type=script&lang=js"
import style0 from "./FundDetails.vue?vue&type=style&index=0&id=6c9d02fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d02fa",
  null
  
)

export default component.exports